import type { Delivery } from "@types_def/models/delivery.types";
export const PriceCell = ({ children }: { children?: Pick<Delivery, "accepted_offer"> }) => {
  const price = children?.accepted_offer?.demandedPrice;

  if (!price) {
    return <i>Error</i>;
  }

  return <div>{price} €</div>;
};
